import { HttpContextToken } from "@angular/common/http";

export const HTTP_CONTEXT_TOKEN_NO_SWAP_DEEP_PROPERTY_ID = new HttpContextToken(
  () => false
);

export const HTTP_CONTEXT_TOKEN_NO_CACHE = new HttpContextToken(() => false);

export const HTTP_CONTEXT_TOKEN_NO_TOKEN = new HttpContextToken(() => false);
